import styles from "./LegalityContent.module.scss";
import { LegalityScreens } from "../../common/types/enums";
import { useTheme } from "../../common/hooks/useTheme";

interface LegalityContentProps {
  screen: LegalityScreens;
}

const userAgreementText = `
ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ

1. ОБЩИЕ ПОЛОЖЕНИЯ

1.1. Настоящее Пользовательское соглашение (далее – Соглашение) относится к сайту «QS Oil», расположенному по адресу https://qsoil.ru.

1.2. Сайт «QS Oil» (далее – Сайт) является собственностью юридического лица ООО «Карьер-Сервис» (ИНН: 7814412486, КПП 781301001, юридический адрес: 197046, Санкт-Петербург, МО Посадский, улица Чапаева, дом 3 литер Б, пом. 7Н/9Н/10Н/11Н).

1.3. Настоящее Соглашение регулирует отношения между Администрацией сайта «QS Oil» (далее – Администрация сайта) и Пользователем данного Сайта.

1.4. Администрация сайта оставляет за собой право в одностороннем порядке изменять, добавлять или удалять пункты настоящего Соглашения без уведомления Пользователя. Новая редакция Соглашения вступают в силу с момента ее размещения на Сайте.

1.5. Использование Сайта Пользователем означает принятие Соглашения и изменений, внесенных в настоящее Соглашение.

1.6. Пользователь несет персональную ответственность за проверку настоящего Соглашения на наличие изменений в нем.

1.7. Обработка персональных данных Пользователя при посещении Сайта осуществляется в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» и Политикой обработки персональных данных, размещенной на Сайте по адресу: https://qsoil.ru/policy/.

2. ОПРЕДЕЛЕНИЯ ТЕРМИНОВ

2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения следующее значение:

2.1.1 «QS Oil» – Интернет-ресурс, расположенный на доменном имени https://qsoil.ru, осуществляющий свою деятельность посредством Интернет-ресурса и сопутствующих ему сервисов (далее - Сайт).

2.1.2. «QS Oil» – сайт, содержащий информацию о Товарах и/или Услугах и/или Иных ценностях для пользователя, Продавце и/или Исполнителе услуг, позволяющий осуществить выбор, заказ и(или) приобретение Товара, и/или получение услуги.

2.1.3. Администрация сайта – уполномоченные сотрудники на управления Сайтом, действующие от имени название организации.

2.1.4. Пользователь сайта (далее - Пользователь) – лицо, имеющее доступ к Сайту, по средством сети Интернет и использующее Сайт.

2.1.5. Содержание сайта (далее – Содержание) - охраняемые результаты интеллектуальной деятельности, включая тексты литературных произведений, их названия, предисловия, аннотации, статьи, иллюстрации, обложки, музыкальные произведения с текстом или без текста, графические, текстовые, фотографические, производные, составные и иные произведения, пользовательские интерфейсы, визуальные интерфейсы, названия товарных знаков, логотипы, программы для ЭВМ, базы данных, а также дизайн, структура, выбор, координация, внешний вид, общий стиль и расположение данного Содержания, входящего в состав Сайта и другие объекты интеллектуальной собственности все вместе и/или по отдельности, содержащиеся на сайте https://qsoil.ru.

3. ПРЕДМЕТ СОГЛАШЕНИЯ

3.1. Предметом настоящего Соглашения является предоставление Пользователю доступа к содержащимся на Сайте Товарам и/или оказываемым услугам.

3.1.1. Сайт предоставляет Пользователю следующие виды услуг (сервисов):

доступ к средствам поиска и навигации сайта;
доступ к информации о Товаре и/или услуге к информации о приобретении Товара на платной/бесплатной основе;

3.1.2. Под действие настоящего Соглашения подпадают все существующие (реально функционирующие) на данный момент услуги (сервисы) Сайта, а также любые их последующие модификации и появляющиеся в дальнейшем дополнительные услуги (сервисы).

3.2. Доступ к сайту предоставляется на бесплатной основе.

3.3. Настоящее Соглашение является публичной офертой. Получая доступ к Сайту Пользователь считается присоединившимся к настоящему Соглашению.

3.4. Использование материалов и сервисов Сайта регулируется нормами действующего законодательства Российской Федерации.

4. ПРАВА И ОБЯЗАННОСТИ СТОРОН

4.1. Администрация сайта вправе изменять правила пользования Сайтом, а также изменять содержание данного Сайта. Изменения вступают в силу с момента публикации новой редакции Соглашения на Сайте.

4.2. Пользователь вправе:

4.2.1. Пользоваться всеми имеющимися на Сайте услугами, а также приобретать любые Товары и/или Услуги, предлагаемые на Сайте.

4.2.2. Задавать любые вопросы, относящиеся к услугам сайта:

по телефону: +7 (812) 449-4406
по электронной почте: info@qsoil.ru

4.2.3. Пользоваться Сайтом исключительно в целях и порядке, предусмотренных Соглашением и незапрещенных законодательством Российской Федерации.

4.2.4. Копировать информацию с Сайта запрещается.

4.2.5. Требовать от администрации скрытия любой информации о пользователе.

4.2.6. Использовать информацию сайта для личных некоммерческих целей.

4.3. Пользователь Сайта обязуется:

4.3.1. Предоставлять по запросу Администрации сайта дополнительную информацию, которая имеет непосредственное отношение к предоставляемым услугам данного Сайта.

4.3.2. Соблюдать имущественные и неимущественные права авторов и иных правообладателей при использовании Сайта.

4.3.3. Не предпринимать действий, которые могут рассматриваться как нарушающие нормальную работу Сайта.

4.3.4. Не распространять с использованием Сайта любую конфиденциальную и охраняемую законодательством Российской Федерации информацию о физических либо юридических лицах.

4.3.5. Избегать любых действий, в результате которых может быть нарушена конфиденциальность охраняемой законодательством Российской Федерации информации.

4.3.6. Не использовать Сайт для распространения информации рекламного характера, иначе как с согласия Администрации сайта.

4.3.7. Не использовать сервисы с целью:

4.3.7.1. нарушения прав несовершеннолетних лиц и (или) причинение им вреда в любой форме.

4.3.7.2. ущемления прав меньшинств.

4.3.7.3. представления себя за другого человека или представителя организации и (или) сообщества без достаточных на то прав, в том числе за сотрудников данного сайта.

4.3.7.4. введения в заблуждение относительно свойств и характеристик какого-либо Товара из каталога, размещенного на Сайте.

4.3.7.5. некорректного сравнения Товара и/или Услуги, а также формирования негативного отношения к лицам, (не) пользующимся определенными Товарами и/или услугами, или осуждения таких лиц.

4.3.8. Обеспечить достоверность предоставляемой информации.

4.3.9. Обеспечивать сохранность личных данных от доступа третьих лиц.

4.4. Пользователю запрещается:

4.4.1. Использовать любые устройства, программы, процедуры, алгоритмы и методы, автоматические устройства или эквивалентные ручные процессы для доступа, приобретения, копирования или отслеживания содержания Сайта.

4.4.2. Нарушать надлежащее функционирование Сайта.

4.4.3. Любым способом обходить навигационную структуру Сайта для получения или попытки получения любой информации, документов или материалов любыми средствами, которые специально не представлены сервисами данного Сайта.

4.4.4. Несанкционированный доступ к функциям Сайта, любым другим системам или сетям, относящимся к данному Сайту, а также к любым услугам, предлагаемым на Сайте.

4.4.4. Нарушать систему безопасности или аутентификации на Сайте или в любой сети, относящейся к Сайту.

4.4.5. Выполнять обратный поиск, отслеживать или пытаться отслеживать любую информацию о любом другом Пользователе Сайта.

4.4.6. Использовать Сайт и его Содержание в любых целях, запрещенных законодательством Российской Федерации, а также подстрекать к любой незаконной деятельности или другой деятельности, нарушающей права Сайта или других лиц.

5. ИСПОЛЬЗОВАНИЕ САЙТА

5.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется Администрацией сайта.

5.2. Содержание Сайта не может быть скопировано, опубликовано, воспроизведено, передано или распространено любым способом, а также размещено в глобальной сети «Интернет» без предварительного письменного согласия Администрации сайта.

5.3. Содержание Сайта защищено авторским правом, законодательством о товарных знаках, а также другими правами, связанными с интеллектуальной собственностью, и законодательством о недобросовестной конкуренции.

5.4. Настоящее Соглашение распространяет свое действия на все дополнительные положения и условия о покупке Товара и/или оказанию услуг, предоставляемых на Сайте.

5.5. Информация, размещаемая на Сайте не должна истолковываться как изменение настоящего Соглашения.

5.6. Администрация сайта имеет право в любое время без уведомления Пользователя вносить изменения в перечень Товаров и услуг, предлагаемых на Сайте, и (или) их цен.

5.7. Документ указанный в пункте 5.8 настоящего Соглашения регулирует в соответствующей части и распространяют свое действие на использование Пользователем Сайта:

5.8. Политика конфиденциальности: https://qsoil.ru/terms/.

5.9. Любой из документов настоящего Соглашения может подлежать обновлению. Изменения вступают в силу с момента их опубликования на Сайте.

6. ОТВЕТСТВЕННОСТЬ

6.1. Любые убытки, которые Пользователь может понести в случае умышленного или неосторожного нарушения любого положения настоящего Соглашения, а также вследствие несанкционированного доступа к коммуникациям другого Пользователя, Администрацией сайта не возмещаются.

6.2. Администрация сайта не несет ответственности за:

6.2.1. Задержки или сбои в процессе совершения операции, возникшие вследствие непреодолимой силы, а также любого случая неполадок в телекоммуникационных, компьютерных, электрических и иных смежных системах.

6.2.2. Надлежащее функционирование Сайта, в случае, если Пользователь не имеет необходимых технических средств для его использования, а также не несет никаких обязательств по обеспечению пользователей такими средствами.

7. НАРУШЕНИЕ УСЛОВИЙ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ

7.1. Администрация сайта имеет право раскрыть информацию о Пользователе, если действующее законодательство Российской Федерации требует или разрешает такое раскрытие.

7.2. Администрация сайта вправе без предварительного уведомления Пользователя прекратить и (или) заблокировать доступ к Сайту, если Пользователь нарушил настоящее Соглашение или содержащиеся в иных документах условия пользования Сайтом, а также в случае прекращения действия Сайта, либо по причине технической неполадки или проблемы.

7.3. Администрация сайта не несет ответственности перед Пользователем или третьими лицами за прекращение доступа к Сайту в случае нарушения Пользователем любого положения настоящего Соглашения или иного документа, содержащего условия пользования Сайтом.

7.4. Администрация сайта вправе раскрыть любую собранную о Пользователе данного Сайта информацию, если раскрытие необходимо в связи с расследованием или жалобой в отношении неправомерного использования Сайта, либо для установления (идентификации) Пользователя, который может нарушать или вмешиваться в права Администрации сайта или в права других Пользователей Сайта.

7.5. Администрация сайта имеет право раскрыть любую информацию о Пользователе, которую посчитает необходимой для выполнения положений действующего законодательства или судебных решений, обеспечения выполнения условий настоящего Соглашения, защиты прав или безопасности название организации, Пользователей.

8. РАЗРЕШЕНИЕ СПОРОВ

8.1. В случае возникновения любых разногласий или споров между Сторонами настоящего Соглашения обязательным условием до обращения в суд является предъявление претензии (письменного предложения о добровольном урегулировании спора).

8.2. Получатель претензии в течение 30 календарных дней со дня ее получения, письменно уведомляет заявителя претензии о результатах рассмотрения претензии.

8.3. При невозможности разрешить спор в добровольном порядке любая из Сторон вправе обратиться в суд за защитой своих прав, которые предоставлены им действующим законодательством Российской Федерации.

8.4. Любой иск в отношении условий использования Сайта должен быть предъявлен в течение 5 дней после возникновения оснований для иска, за исключением защиты авторских прав на охраняемые в соответствии с законодательством материалы Сайта. При нарушении условий данного пункта любой иск оставляется судом без рассмотрения.

9. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ

9.1. Администрация сайта не принимает встречные предложения от Пользователя относительно изменений настоящего Пользовательского соглашения.

9.2. Отзывы Пользователя, размещенные на Сайте, не являются конфиденциальной информацией и могут быть использованы Администрацией сайта без ограничений.

Обновлено «1» июля 2022 г.
`;

const privacyPolicyText = `
ПОЛИТИКА В ОТНОШЕНИИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ

Редакция от «22» сентября 2025 г.

1. Общие положения

1.1. Политика ООО «Карьер-Сервис» (ОГРН 1089847270402; ИНН 7814412486; 197046, Санкт-Петербург, МО Посадский, улица Чапаева, дом 3 литер Б, пом. 7Н/9Н/10Н/11Н) в области обработки персональных данных (далее – «Политика») определяет основные принципы и условия обработки персональных данных (далее – «ПДн») в ООО «Карьер-Сервис» (далее – «Общество»), а также меры по обеспечению безопасности ПДн в Обществе.

1.2. Политика разработана в соответствии с требованиями Федерального закона от 27.07.2006 №152-ФЗ «О персональных данных» (далее – Закон №152-ФЗ «О персональных данных»), иных федеральных законов, регулирующих вопросы обработки ПДн, а также принятых во исполнение подзаконных нормативных правовых актов РФ.

1.3. Политика направлена на обеспечение прав и свобод человека и гражданина при обработке Обществом ПДн, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну в соответствии с требованиями действующего законодательства РФ.

1.4. Политика публикуется на сайте Общества в информационно-телекоммуникационной сети «Интернет» по адресу: http://qsoil.ru/.

1.5. Правовым основанием обработки ПДн в Обществе являются:

Конституции Российской Федерации;
Трудовой кодекс Российской Федерации;
Гражданский кодекс Российской Федерации;
Федеральный закон от 27.07.2006 №152-ФЗ «О персональных данных»;
Федеральный закон от 08.02.1998 №14-ФЗ «Об обществах с ограниченной ответственностью»;
Указ Президента Российской Федерации от 06.03.1997 №188 «Об утверждении Перечня сведений конфиденциального характера»;
Постановление Правительства Российской Федерации от 15.09.2008 №687 «Об утверждении Положения об особенностях обработки персональных данных, осуществляемой без использования средств автоматизации»;
Постановление Правительства Российской Федерации от 01.11.2012 №1119 «Об утверждении требований к защите персональных данных при их обработке в информационных системах персональных данных»;
Иные нормативные правовые акты органов государственной власти Российской Федерации;
Согласия субъектов ПДн на обработку, распространение и передачу третьим ПДн, оформленные с учетом требований законодательства Российской Федерации для соответствующей категории ПДн;
Договоры, заключаемые между Обществом и субъектом ПДн, либо третьим лицом, по которым субъект ПДн является выгодоприобретателем или поручителем.

1.6. В Политике используются следующие термины и определения:

1.6.1. Автоматизированная обработка ПДн – обработка ПДн с помощью средств вычислительной техники.

1.6.2. Блокирование ПДн – временное прекращение обработки ПДн (за исключением случаев, если обработка необходима для уточнения персональных данных).

1.6.3. Доступ к ПДн – ознакомление определенных лиц (в том числе работников Общества) с ПДн субъектов, обрабатываемыми при условии сохранения конфиденциальности этих сведений.

1.6.4. Информационная система ПДн (ИСПДн) – совокупность содержащихся в базах данных ПДн и обеспечивающих их обработку информационных технологий и технических средств.

1.6.5. Конфиденциальность ПДн – обязанность лиц, получивших доступ к ПДн, не раскрывать третьим лицам и не распространять ПДн без согласия субъекта ПДн, если иное не предусмотрено законодательством.

1.6.6. Обезличивание ПДн – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность ПДн конкретному субъекту ПДн.

1.6.7. Обработка ПДн – любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с ПДн, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, уничтожение ПДн.

1.6.8. Общедоступные ПДн – ПДн, доступ неограниченного круга лиц к которым предоставлен на основании законодательства субъектом ПДн, либо по его просьбе, в том числе данные, которые подлежат обязательному раскрытию или опубликованию.

1.6.9. Оператор – юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующее и (или) осуществляющее обработку ПДн, а также определяющее цели обработки ПДн, состав ПДн, подлежащих обработке, действия (операции), совершаемые с ПДн. В рамках настоящей Политики Оператором является ООО «Карьер-Сервис» (ОГРН 1089847270402; ИНН 7814412486; 197046, Санкт-Петербург, МО Посадский, улица Чапаева, дом 3 литер Б, пом. 7Н/9Н/10Н/11Н).

1.6.10. Ответственный за организацию обработки ПДн в Обществе – назначенный приказом Генерального директора Общества работник Общества, отвечающий за соблюдение Обществом и его работниками законодательства Российской Федерации в области ПДн, в том числе требований к защите ПДн.

1.6.11. Персональные данные (ПДн) – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту ПДн).

1.6.12. Пользователь — физические лица, просматривающие и/или использующие Сайт и информацию размещенную на Сайте.

1.6.13. Предоставление ПДн – действия, направленные на раскрытие ПДн определенному лицу или определенному кругу лиц.

1.6.14. Распространение ПДн – действия, направленные на раскрытие ПДн неопределенному кругу лиц.

1.6.15. Сайт - официальный веб-ресурс, размещенный по адресу: http://qsoil.ru/ (включая поддомены (субдомены)), который предназначен для представления деятельности Общества, продуктов, услуг и ценностей Общества в интернете.

1.6.16. Специальные категории ПДн – сведения, касающиеся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни.

1.6.17. Субъект ПДн – физическое лицо, к которому относятся персональные данные.

1.6.18. Уничтожение ПДн – действия, в результате которых становится невозможным восстановить содержание ПДн в информационной системе ПДн и (или) в результате которых уничтожаются материальные носители ПДн.

1.6.19. Файл cookie – это небольшой фрагмент данных, который Сайт запрашивает у браузера, используемого на компьютере или мобильном устройстве Пользователя. Технология cookie позволяет Сайту запомнить действия и предпочтения Пользователя. Файлы cookie хранятся локально на компьютере или мобильном устройстве Пользователя. Пользователи могут удалить сохраненные файлы cookie по своему желанию через настройки браузера.

1.7. Обработки ПДн в Обществе осуществляется на основании следующих принципов:

1.7.1. законности и справедливой основы;
1.7.2. ограничения обработки ПДн достижением конкретных, заранее определенных и законных целей;
1.7.3. недопущения обработки ПДн, несовместимой с целями сбора ПДн;
1.7.4. недопущения объединения баз данных, содержащих ПДн, обработка которых осуществляется в целях, несовместимых между собой;
1.7.5. обработки только тех ПДн, которые отвечают целям их обработки;
1.7.6. соответствия содержания и объема обрабатываемых ПДн заявленным целям обработки;
1.7.7. недопущения обработки ПДн, избыточных по отношению к заявленным целям их обработки;
1.7.8. обеспечения точности, достаточности и актуальности ПДн по отношению к целям обработки персональных данных;
1.7.9. уничтожения либо обезличивания ПДн по достижении целей их обработки или в случае утраты необходимости в достижении этих целей, при невозможности устранения Оператором допущенных нарушений ПДн, если иное не предусмотрено федеральным законом.

1.8. Находясь на Сайте и проставляя отметку в чекбоксе или нажимая кнопку «Согласен», Пользователь Сайта выражает свое безоговорочное согласие с настоящей Политикой и указанными в ней условиями обработки его ПДн.

1.9. Пользователь вправе отказаться от использования cookie на Сайте, воспользовавшись инструкцией, опубликованной по ссылке: https://qsoil.ru/cookies-policy/.

2. Цели и способы обработки персональных данных

2.1. Обработке подлежат только ПДн, которые отвечают целям их обработки. В частности, Общество может обрабатывать ПДн для достижения целей, указанных в Приложении №1 к Политике. Не допускается обработка ПДн, несовместимая с целями обработки ПДн.

2.2. ПДн могут обрабатываться Обществом также в иных целях, перечень ПДн, категории субъектов ПДн, чьи ПДн обрабатываются в Обществе, а также объем обрабатываемых ПДн, определяются в соответствии с законодательством Российской Федерации и локальными нормативными актами Общества.

2.3. Обработка ПДн в Обществе осуществляется следующими способами:

неавтоматизированная обработка ПДн;
автоматизированная обработка ПДн с передачей полученной информации по информационно-телекоммуникационным сетям;
смешанная обработка ПДн.

2.4. Обработка ПДн Обществом, в том числе посредством информационно-телекоммуникационной сети «Интернет», осуществляется следующими способами: запись, сбор, систематизация, накопление, хранение, уточнение (обновление, изменение), обезличивание, извлечение, использование, передача (предоставление, доступ), блокирование, удаление, уничтожение ПДн.

2.5. Обществом не осуществляется обработка посредством информационно-телекоммуникационной сети «Интернет» биометрических ПДн, специальных категорий ПДн, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни.

2.6. При сборе ПДн, в том числе посредством информационно-телекоммуникационной сети «Интернет», Общество обеспечивает обработку ПДн граждан Российской Федерации с использованием баз данных, находящихся на территории Российской Федерации.

2.7. К обработке ПДн допускаются работники Общества, в должностные обязанности которых входит обработка ПДн.

2.8. Обработка ПДн прекращается при достижении одного из следующих условий:

достижение целей обработки ПДн и максимальных сроков хранения документов, их содержащих;
утрата необходимости в достижении целей обработки ПДн;
выявление неправомерной обработки ПДн;
отзыв субъектом ПДн согласия на обработку ПДн, за исключением случаев, предусмотренных законодательством РФ в области ПДн.

2.9. Хранение ПДн осуществляется в форме, позволяющей определить субъекта ПДн, не дольше, чем этого требуют цели обработки ПДн, если срок хранения ПДн не установлен федеральным законом или договором, стороной которого, выгодоприобретателем или поручителем, по которому является субъект ПДн. Обрабатываемые ПДн уничтожаются по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено законодательством Российской Федерации.

3. Сбор cookie

3.1. На сайтах Общества обрабатываются файлы cookie и применяются инструменты аналитики данных, согласно техническим параметрам применяемых средств, для статистического анализа использования сервисов и обеспечения их работоспособности, как в целом, так и их отдельных функций.

3.2. Под файлами «cookie» понимаются данные о Пользователях Сайта Общества, доступные и собираемые Обществом самостоятельно или с привлечением сервиса Яндекс.Метрика, а именно: перечень cookie: псевдоним (идентификатор) пользователя, адрес пользователя или адрес устройства Пользователя и его технические характеристики, посредством которого пользователь зашел на сайт Общества и (или) установил соединение с интернет-сервисом Общества, используемая операционная система на устройстве пользователя, версия операционной системы, а также сведения о пользователе, включающие IP-адрес, поисковые запросы Пользователя, информацию об используемом браузере и языке, даты и время доступа к сайту, интернет-адреса веб-страниц, посещаемых пользователем, тематику информации, размещенной на посещаемых пользователем интернет-ресурсах Общества, идентификатор устройства, географическое положение, количество просмотренных страниц, длительность пребывания на сайте Общества, запросы, которые пользователь использовал при переходе на сайт, страницы, с которых были совершены переходы, идентификатор сессии, время авторизации/регистрации, и любая информация, не позволяющая однозначно идентифицировать Пользователя или конкретное физическое лицо, для предоставления пользователю рекламной информации и аналитическая пользовательская информация. Пользователи сайта уведомляются о сборе файлов cookie при переходе на Сайт.

3.3. На Сайте Общества используются следующие параметры cookie согласно Политике в отношении файлов cookie.

3.4. Сведения об обрабатываемых данных и политике конфиденциальности Организаций-поставщиков аналитических услуг представлены ниже:

«Яндекс.Формы»: https://forms.yandex.ru (Условия использования сервиса Яндекс.Формы для создателей форм https://yandex.ru/legal/forms_creators/;
Условия использования сервиса https://yandex.ru/legal/forms_respondents/;
Яндекс.Формы Политика для респондентов конфиденциальности https://yandex.ru/legal/confidential/).

3.5. Параметрами использования cookie Пользователь Сайта может управлять самостоятельно в настройках своего браузера.

3.6. Обрабатываемые файлы cookie уничтожаются в случае достижении целей обработки или в случае утраты необходимости в обработке таких сведений.

3.7. Пользователь сайта вправе отказаться от использования Яндекс.Метрики, воспользовавшись инструкцией, опубликованной по ссылке: https://yandex.com/support/metrica/general/opt-out.html?lang=ru.

4. Права субъекта персональных данных

4.1. Субъект ПДн принимает решение о предоставлении его ПДн и дает согласие на их обработку свободно, своей волей и в своем интересе. Согласие на обработку ПДн может быть дано Субъектом ПДн или его представителем в любой позволяющей подтвердить факт его получения форме, если иное не установлено законодательством РФ, в том числе путем приостановления отметки в чекбоксе.

4.2. При обработке ПДн Субъекты ПДн вправе:

запросить информацию, касающуюся обработки его ПДн;
потребовать уточнения, уничтожения или блокирования его ПДн, если ПДн являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;
отозвать предоставленные Обществу согласия на обработку ПДн.

4.3. В предоставляемые по запросу Субъекта ПДн сведения не включаются ПДн, относящиеся к другим субъектам ПДн, за исключением случаев, когда имеются законные основания для раскрытия таких ПДн.

4.4. В соответствии с п. 3 ст. 14 Закона №152-ФЗ «О персональных данных», информация, касающаяся обработки ПДн Субъекта ПДн может быть предоставлена субъекту ПДн или его законному представителю Обществом при обращении, либо при получении запроса Субъекта ПДн или его законного представителя.

4.5. Запрос должен содержать:

номер основного документа, удостоверяющего личность субъекта ПДн либо их представителя, сведения о дате выдачи указанного документа, и о выдавшем его органе;
сведения, подтверждающие участие Субъекта ПДн в отношениях с Обществом, либо сведения, иным образом подтверждающие факт обработки ПДн Обществом;
подпись Субъекта ПДн или его представителя.

4.6. Запросы в части предоставления информации об обработке ПДн, а также запросы на уточнение, изменение или прекращение обработки ПДн и отзывы согласия на обработку ПДн могут направляться в письменном виде заказным почтовым отправлением по адресу Общества, указанному на Сайте в разделе «Контакты», либо иным способом, предусмотренным ст. 14 Закона №152-ФЗ «О персональных данных».

4.7. Если в запросе Субъекта ПДн не отражены все необходимые сведения или Субъект ПДн не обладает правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ. Право Субъекта ПДн на доступ к его персональным данным может быть ограничено в соответствии с ч. 8 ст. 14 Закона №152-ФЗ «О персональных данных», в том числе если доступ Субъекта ПДн к его ПДн нарушает права и законные интересы третьих лиц.

4.8. Общество обязуется в течение 10 (Десяти) рабочих дней с даты получения соответствующего запроса:

безвозмездно предоставить Субъекту ПДн или его представителю запрашиваемую информацию, либо дать в письменной форме мотивированный отказ в предоставлении информации;
уведомить Субъекта ПДн или его представителя о внесенных изменениях и предпринятых мерах;
уведомить Субъекта ПДн или его представителя об устранении допущенных нарушений или об уничтожении ПДн, в случае выявления неправомерной обработки ПДн.

Указанный в настоящем пункте срок может быть продлен, но не более чем на 5 (пять) рабочих дней в случае направления Обществом в адрес Субъекта ПДн мотивированного уведомления с указанием причин продления срока предоставления запрашиваемой информации.

4.9. В случае обращения Субъекта ПДн к Обществу с требованием о прекращении обработки ПДн Общество обязано в срок, не превышающий 10 (Десяти) рабочих дней с даты получения Обществом соответствующего требования, прекратить их обработку или обеспечить прекращение такой обработки (если такая обработка осуществляется лицом, осуществляющим обработку ПДн), за исключением случаев, предусмотренных пунктами 2 — 11 ч. 1 ст. 6, ч. 2 ст. 10 и ч. 2 ст. 11 Закона №152-ФЗ «О персональных данных».

5. Сведения о реализуемых требованиях к защите персональных данных

5.1. Общество принимает меры, необходимые и достаточные для обеспечения выполнения обязанностей, возложенных на него в соответствии с действующим законодательством Российской Федерации в области ПДн, в том числе:

5.1.1. В Обществе издаются и актуализируются документы, определяющие политику Общества в отношении обработки ПДн, локальные нормативные документы, устанавливающие правила обработки ПДн, а также локальные нормативные документы, устанавливающие процедуры, направленные на предотвращение и выявление нарушений законодательства Российской Федерации в области ПДн, устранение последствий таких нарушений.

5.1.2. В Обществе применяются организационные и технические меры по обеспечению безопасности ПДн в соответствии с ч. 2 ст. 19 Закона №152-ФЗ «О персональных данных», в том числе:

определяются угрозы безопасности ПДн при их обработке в информационных системах ПДн;
применяются организационные и технические меры по обеспечению безопасности ПДн при их обработке в информационных системах ПДн, необходимых для выполнения требований к защите ПДн, исполнение которых обеспечивает установленные Правительством Российской Федерации уровни защищенности ПДн;
применяются прошедшие в установленном порядке процедуру оценки соответствия средства защиты информации при наличии обоснованной необходимости;
производится оценка эффективности принимаемых мер по обеспечению безопасности ПДн до ввода в эксплуатацию информационной системы ПДн;
производится обнаружение фактов несанкционированного доступа к ПДн и принимаются соответствующие меры;
производится установление правил доступа к ПДн, обрабатываемым в информационной системе ПДн;
производится контроль за принимаемыми мерами по обеспечению безопасности ПДн и уровня защищенности информационных систем ПДн.

5.1.3. Осуществляется контроль соответствия обработки ПДн требованиям законодательства РФ в области ПДн и требованиям по защите ПДн.

5.1.4. Производится оценка вреда, который может быть причинен субъектам ПДн в случае нарушения Закона, соотношение указанного вреда и принимаемых Обществом мер, направленных на обеспечение выполнения обязанностей, предусмотренных Законом.

5.1.5. Производится ознакомление работников Общества, непосредственно осуществляющих обработку ПДн, с положениями законодательства Российской Федерации о ПДн, в том числе требованиями по защите ПДн, документами, определяющими политику в отношении обработки ПДн, локальными нормативными документами Общества по вопросам обработки ПДн.

5.1.6. В соответствии с приказом генерального директора Общества, в Обществе назначено лицо, ответственное за организацию обработки ПДн. Ответственный за организацию обработки ПДн в Обществе – Директор по персоналу, е-mail: info@qsspb.ru.

5.1.7. Настоящая Политика применима только к Сайту Общества и не регулирует сайты третьих лиц, на которые Пользователь может перейти по ссылкам, доступным на Сайте или указанном в настоящей Политике. На сайте третьих лиц могут запрашиваться и собираться иные ПДн.

6. Изменение Политики

6.1. Общество вправе в одностороннем порядке в любой момент изменять условия Политики. При внесении изменения в актуальной редакции указывается дата последнего обновления. Общество рекомендует регулярно проверять содержание настоящей Политики на предмет ее возможных изменений.

6.2. Новая редакция Политики вступает в силу с момента ее размещения на сайте Общества по адресу http://qsoil.ru/, если иное не предусмотрено новой редакцией Политики.

6.3. Актуальная версия Политики действует бессрочно до замены её новой версией.
`;

const cookiePolicyText = `
ПОЛИТИКА ИСПОЛЬЗОВАНИЯ COOKIE-ФАЙЛОВ

Настоящая политика применения веб-технологий («Политика использования файлов cookie») устанавливает правила, согласно которым ООО «Карьер-Сервис» управляет своим веб-сайтом и защищает при этом интересы посетителей сайта в отношении конфиденциальности передаваемых данных.

Файлы cookie

В соответствии с настройками вашего браузера файл cookie позволяет автоматически собирать информацию, направляемую нам вашим веб-браузером при доступе на наш веб-сайт. Как правило, эта информация содержит IP-адрес, присвоенный в настоящий момент вашему компьютеру, а также сведения о типе установленной операционной системы и браузера.

Файл cookie — это небольшой текстовый файл, который сохраняется на ваш жесткий диск веб-сервером.

Мы различаем «сеансовые файлы cookie» и «постоянные файлы cookie».

Сеансовые файлы cookie

Мы пользуемся сеансовыми файлами cookie для присвоения вашему компьютеру уникального случайного идентификационного номера при каждом посещении нашего веб-сайта. Сеансовые файлы cookie уничтожаются при закрытии браузера. Мы используем сеансовые файлы cookie для поддержания функций нашего веб-сайта и определения вариантов использования вами нашего веб-сайта, т.е. получения сведений о посещаемых вами страницах, используемых ссылках и длительности пребывания на каждой странице.

Постоянные файлы cookie

В дозволенных случаях мы используем постоянные файлы cookie, которые не удаляются сразу после закрытия браузера, а остаются на вашем компьютере до истечения срока их действия по окончании установленного периода или до тех пор, пока вы не сотрете их самостоятельно. При каждом посещении нашего веб-сайтов наш сервер сможет определить наличие постоянного файла cookie на жестком диске вашего компьютера. Присвоив вашему компьютеру уникальный постоянный идентификатор, мы сможем создать базу данных с информацией о ваших предпочтениях и выбранных вами настройках. Уникальный идентификатор также помогает нам более точно определить, как часто вы посещаете наш веб-сайт, как часто вы возвращаетесь, как изменяется характер ваших посещений со временем и насколько эффективен наш маркетинг. Однако в состав данной информации не входят ваши личные данные; она позволяет составить представление только о маршрутах вашего перемещения по нашим сайтом. При доступе на наш веб-сайт, используя направленное вам электронное письмо, или при создании вами «идентификатора пользователя» во время одного из посещений, файлы cookie, предоставленные нами или нашим сторонним провайдером услуг, могут быть связаны с информацией, которая содержится в определяющей вас учетной документации.

Согласие на использование файлов cookie

Ваше предварительное согласие на использование сеансовых файлов cookie не требуется, так как они необходимы для функционирования веб-сайта, и срок их действия истекает сразу же после того, как вы покинете сайт. Применение постоянных файлов cookie с информацией о выбранных вами параметрах и предпочтениях, если эти файлы cookie не нужны для работы сайта, допускается только с вашего предварительного прямого согласия. Осуществляя навигацию по нашему веб-сайту, вы даете согласие на использование постоянных файлов cookie, если вы не изменили настройки компьютера, чтобы заблокировать установку таких файлов cookie. Это правило распространяется на сторонние файлы cookie.

Как изменить настройки файлов cookie

Настройка конфигурации Интернет-браузера является бесплатным и эффективным способом управления файлами cookie. Можно выбрать следующие варианты:

возможность использования всех файлов cookie, интегрированных на страницы и в просматриваемое вами содержание. Примечание. С одной стороны, прочитать эти файлы cookie смогут только их отправители. С другой стороны, этот процесс не является окончательным. Всегда можно деактивировать файлы cookie впоследствии (управление файлами cookie может варьироваться в зависимости от типа вашего Интернет-браузера; пожалуйста, ознакомьтесь с соответствующими инструкциями)
блокирование файлов cookie на вашем устройстве. Это скажется на навигации по сайту. Файлы cookie требуются для использования некоторых функций (например, возможно, не будет опознана ваша операционная система или будет отображаться не тот язык сайта). Следовательно, мы не принимаем на себя ответственность за любые неудобства, причиненные возможной некорректностью предоставления наших услуг по причине недоступности файлов cookie
запрос от браузера предоставить согласие или отказ до установки нового файла cookie на ваше устройство;
принять или отклонить файлы cookie в зависимости от отправителя.

Режим управления файлами cookie зависит от вашего браузера. Более подробная информация с инструкциями по использованию:

Internet Explorer
Chrome
Safari
Firefox
Opera
`;

const personalDataAgreementText = `
СОГЛАСИЕ
на обработку персональных данных

Настоящим свободно, своей волей и в своих интересах даю согласие ООО «Карьер-Сервис» (ИНН 7814412486), юридический адрес: 197046, Санкт-Петербург, МО Посадский, улица Чапаева, дом 3 литер Б, пом. 7Н/9Н/10Н/11Н, на обработку моих персональных данных:

- адрес электронной почты
- номер телефона
- адрес доставки
- история заказов

на следующих условиях:

1. Цели обработки
   - создание и ведение аккаунта
   - авторизация с использованием кодов подтверждения
   - оформление и доставка заказов
   - информирование о статусе заказов
   - улучшение качества обслуживания

2. Способы обработки
   - сбор, запись, систематизация
   - накопление, хранение, уточнение
   - использование
   - передача курьерским службам (телефон, адрес доставки)
   - передача обработчику ПД НОЧЕВКИНУ С.М. (реестр РКН № 100340655) для обеспечения работы Сайта
   - удаление

3. Срок действия
   Настоящее согласие действует с момента его подтверждения на Сайте и до достижения целей обработки или отзыва согласия.

4. Отзыв согласия
   Согласие может быть отозвано путем направления письменного заявления на юридический адрес Оператора или на адрес электронной почты: support@qsoil.ru.
`;

export const QsoilLegalityContent = ({ screen }: LegalityContentProps) => {
  const { theme } = useTheme();

  const getText = () => {
    switch (screen) {
      case LegalityScreens.USER_AGREEMENT:
        return userAgreementText;
      case LegalityScreens.PRIVACY_POLICY:
        return privacyPolicyText;
      case LegalityScreens.PERSONAL_DATA_AGREEMENT:
        return personalDataAgreementText;
      case LegalityScreens.COOKIE_POLICY:
        return cookiePolicyText;
      default:
        return userAgreementText;
    }
  };

  const fullText = getText();

  const renderText = () => {
    const lines = fullText.trim().split("\n");

    return lines.map((line, index) => {
      const trimmed = line.trim();

      if (!trimmed) {
        return <div key={index} className={styles.spacer} />;
      }

      if (
        trimmed.startsWith("ПОЛЬЗОВАТЕЛЬСКОЕ") ||
        trimmed.startsWith("ПОЛИТИКА") ||
        trimmed.startsWith("СОГЛАСИЕ")
      ) {
        return (
          <h2
            key={index}
            className={styles.title}
            style={{ color: theme.text }}
          >
            {trimmed}
          </h2>
        );
      }

      if (trimmed.match(/^\d+\./)) {
        return (
          <h3
            key={index}
            className={styles.sectionTitle}
            style={{ color: theme.text }}
          >
            {trimmed}
          </h3>
        );
      }

      return (
        <p key={index} className={styles.text} style={{ color: theme.text }}>
          {trimmed}
        </p>
      );
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.scrollView}>{renderText()}</div>
    </div>
  );
};
